import React from 'react';
import { Spacer, Text } from '@ontruck/orc';

const csaJourneyOwnershipRenderer = ({ changes: { rule_used, current_owner }, ...props }) => {
  return (
    <Spacer {...props}>
      {!!rule_used && (
        <Text color="grey800" display="block">
          Rule: {rule_used}
        </Text>
      )}
      {!!current_owner && (
        <Text color="grey800" display="block">
          Owner: {current_owner}
        </Text>
      )}
    </Spacer>
  );
};

export default csaJourneyOwnershipRenderer;
